import { getFieldComponent, componentRegistry } from "./ComponentRegistry";
import type { FieldProps } from "./ComponentRegistry";

interface Field extends FieldProps {
  type: string;
}

interface DynamicRendererProps {
  field: Field;
}

/**
 * Dynamic Renderer that automatically handles new field types from backend
 * Unknown field types will use GenericField with consistent styling
 */
export function DynamicRenderer({ field }: DynamicRendererProps) {
  const Component = getFieldComponent(field.type);

  // Log unknown field types for monitoring, but still render them
  if (!componentRegistry[field.type] && field.type !== "default") {
    console.info(
      `New field type "${field.type}" detected, using GenericField with consistent styling`,
    );
  }

  return <Component {...field} />;
}
